import React from "react";
import styles from "./styles.module.sass";

const ShineEffect = ({children}) => {
    return <div className={styles.shine}>{children}</div>;
};

export default ShineEffect;
